import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import Login from "@/views/Login/index.vue";

import Root from "@/views/Root.vue";

import Wallets from "@/views/History/Wallets.vue";
import ClientDetail from "@/views/History/ClientDetail.vue";
import BeneficiaryDetail from "@/views/History/BeneficiaryDetail.vue";
import ConversionsHistory from "@/views/History/ConversionsHistory.vue";
import ConversionDetail from "@/views/History/ConversionDetail.vue";
import ConversionActive from "@/views/History/ForwardHistory.vue";
import InvoicesUSD from "@/views/History/InvoicesUSD.vue";
import InvoicesMXN from "@/views/History/InvoicesMXN.vue";
import PaymentsHistory from "@/views/History/PaymentsHistory.vue";
import PaymentDetail from "@/views/History/PaymentDetail.vue";
import InvoiceDetail from "@/views/History/InvoiceDetail.vue";
import Users from "@/views/Users.vue";
import CustomerEnterprises from "@/views/Enterprise.vue";
import IncomesHistory from "@/views/History/Incomes.vue";

import PersonReport from "@/views/Agents/ReportPerson.vue";
import EnterpriseReport from "@/views/Agents/Report.vue";
import HistoryReportIA from "@/views/Agents/HistoryReports.vue";

import Calendario from '@/views/factorajeTradicional/views/Calendario.vue';
import DashboardFactoraje from '@/views/factorajeTradicional/views/Dashboard.vue';

import CedentesList from '@/views/factorajeTradicional/views/CedentesList.vue';
import FacturaList from '@/views/factorajeTradicional/views/FacturaList.vue';

import DeudorList from '@/views/factorajeTradicional/views/DeudorList.vue';
import DeudorDetalle from '@/views/factorajeTradicional/views/DeudorDetalle.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Root",
    component: Root,
    redirect: {
      name: "Emterprises", // Cambiado de Dashboard a Landing
    },
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import('@/views/History/Dashboard.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/enterprises",
        name: "Emterprises",
        component: Wallets,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/client/:sEnterpriseId",
        name: "ClientDetail",
        component: ClientDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/beneficiary/:sEnterpriseId/:sPaymentRecipientId",
        name: "BeneficiaryDetail",
        component: BeneficiaryDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/customerEnterprises",
        name: "customerEnterprises",
        component: CustomerEnterprises,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/conversionHistory",
        name: "conversionHistory",
        component: ConversionsHistory,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/conversionActive",
        name: "conversionActive",
        component: ConversionActive,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/invoicesUSD",
        name: "invoicesUSD",
        component: InvoicesUSD,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/invoicesMXN",
        name: "invoicesMXN",
        component: InvoicesMXN,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/paymentsHistory",
        name: "paymentsHistory",
        component: PaymentsHistory,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payment/:sPaymentId",
        name: "PaymentDetail",
        component: PaymentDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/conversion/:sTransactionId",
        name: "ConversionDetail",
        component: ConversionDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/invoice/:sInvoiceId",
        name: "InvoiceDetail",
        component: InvoiceDetail,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/historyReports",
        name: "HistoryReportIA",
        component: HistoryReportIA,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/reportEnterprise/:idReport",
        name: "ReportEnterprise",
        component: EnterpriseReport,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/reportPerson/:idReport",
        name: "PersonReport",
        component: PersonReport,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/incomesHistory",
        name: "incomesHistory",
        component: IncomesHistory,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/calendario',
        name: 'Calendario',
        component: Calendario,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/dashboard-factoraje',
        name: 'DashboardFactoraje',
        component: DashboardFactoraje,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/clientes',
        name: 'Clientes',
        component: () => import('@/views/factorajeTradicional/views/Contracts.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/invoices',
        name: 'Invoices',
        component: () => import('@/views/factorajeTradicional/views/Invoices.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/lista-cedentes',
        name: 'CedentesList',
        component: CedentesList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/collection-history',
        name: 'CollectionHistory',
        component: () => import('@/views/factorajeTradicional/views/CollectionHistory.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/payment-history',
        name: 'PaymentHistory',
        component: () => import('@/views/factorajeTradicional/views/PaymentHistory.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/factoraje-empresas/:empresaId/facturas',
        name: 'facturasEmpresa',
        component: FacturaList,
        meta: { requiresAuth: true }
      },
      {
        path: '/facturasss/:id',
        name: 'FacturaDetalle',
        component: () => import('@/views/factorajeTradicional/views/FacturaDetalle.vue'),
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: '/lista-deudores',
        name: 'DeudorList',
        component: DeudorList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/lista-recargos',
        name: 'RecargosList',
        component: () => import('@/views/factorajeTradicional/views/RecargosList.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/recargo/:cedenteId',
        name: 'detalleRecargosCedente',
        component: () => import('@/views/factorajeTradicional/views/RecargoDetalle.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/detalleDeudor/:deudorId',
        name: 'detalleDeudor',
        component: DeudorDetalle,
        meta: { requiresAuth: true }
      },
      {
        path: '/factura/:invoiceId',
        name: 'FacturaDeudorDetalle',
        component: () => import('@/views/factorajeTradicional/views/FacturaDeudorDetalle.vue'),
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: '/compliance',
        name: 'Compliance',
        component: () => import('@/views/Compliance/Compliance.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/complianceDocuments',
        name: 'ComplianceDocuments',
        component: () => import('@/views/Compliance/Documents.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/compliance/empresa/:empresaId/:producto',
        name: 'KycDetail',
        component: () => import('@/views/Compliance/Detail.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings/Security.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/credit/dashboard',
        name: 'CreditDashboard',
        component: () => import('@/views/creditsLines/Dashboard.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/credit/credit-lines',
        name: 'CreditLines',
        component: () => import('@/views/creditsLines/CreditLines.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/credit/invoices',
        name: 'Invoices',
        component: () => import('@/views/creditsLines/Invoices.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/credit/draws',
        name: 'Draws',
        component: () => import('@/views/creditsLines/Draws.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/credit/payment-history',
        name: 'PaymentHistory',
        component: () => import('@/views/creditsLines/Payments.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/calculator',
        name: 'ProplatCalculator',
        component: () => import('@/views/ProplatCalculator/index.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/tours',
        name: 'Tours',
        component: () => import('@/views/History/Tours.vue'),
        meta: {
          requiresAuth: true,
        },
      }
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  // When opening a new route send the user to the default location (top left)
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (Store.state.sToken) {
      if (to.name === "Login") {
        next({ name: "Root" }); // Renderiza el componente "Home"
      }
      next();
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    if (Store.state.sToken) {
      if (to.name === "Login") {
        next({ name: "Root" }); // Renderiza el componente "Home"
      }
      next();
    } else {
      next();
    }
  }
});

export default router;
